// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1BBwz","label":"Radio_label__2iYdC","checkMark":"Radio_checkMark__2KVTl","disabled":"Radio_disabled__eO3xL"};